import {
  Checkbox,
  CheckboxGroup,
  Divider,
  Grid,
  Radio,
  RadioGroup,
  Select,
  Textarea,
  TextInput,
} from '@mantine/core';
import { UseFormReturnType } from '@mantine/form/lib/use-form';
import { CurrenciesData } from '../../../../data/currencies-data.array';
import { IndustryListData } from '../../../../data/industry-list-data.array';
import { AcquirerTypes } from '../../../../enums/acquirer-types.enum';
import { BusinessModeOfPayments } from '../../../../enums/business-mode-payments';
import { UpdateMerchantOnboardingFormValues } from '../../../../type/update-merchant-onboarding-form-values.types';

interface UpdateMerchantDescriptionProps {
  form: UseFormReturnType<UpdateMerchantOnboardingFormValues>;
  isNonAdminInterface: boolean;
}
function UpdateMerchantDescription(props: UpdateMerchantDescriptionProps) {
  const { form, isNonAdminInterface } = props;

  const label = {
    isBrickAndMortarStore: 'Do you have a physical store?',
    industry: 'Industry',
    serviceDescription: 'Service description',
    modeOfPayment: 'Mode of payment',
    currency: 'Currency',
    estimatedMonthlyGrossTransaction: 'Estimated Monthly Gross Transaction',
    aubPartnerId: 'AUB partner ID',
    acquirer: 'Acquirer',
  };
  const placeHolder = {
    industry: 'Select industry',
    modeOfPayment: 'Mode of payment',
    currency: 'Currency',
    estimatedMonthlyGrossTransaction: 'Estimated Monthly Gross Transaction',
    aubPartnerId: 'AUB partner ID',
  };

  return (
    <>
      <Grid>
        <Grid.Col xs={12}>
          <RadioGroup
            label={label.isBrickAndMortarStore}
            value={form.values.isBrickAndMortarStore.toString()}
            sx={{ '& label': { fontSize: 14 } }}
            onChange={(value) =>
              form.setFieldValue('isBrickAndMortarStore', value === 'true')
            }
            error={form.errors.isBrickAndMortarStore}
            data-cy="isBrickAndMortarStore"
          >
            <Radio value="true" label="Yes" />
            <Radio value="false" label="No" />
          </RadioGroup>
        </Grid.Col>
        <Grid.Col xs={12}>
          <Select
            placeholder={placeHolder.industry}
            label={label.industry}
            value={form.values.industry}
            data={IndustryListData}
            onChange={(value: string) => {
              form.setFieldValue('industry', value);
            }}
            error={form.errors.industry}
            searchable
            data-cy="industry"
          />
        </Grid.Col>
        <Grid.Col>
          <Textarea
            label={label.serviceDescription}
            autosize
            minRows={5}
            maxRows={5}
            value={form.values.serviceDescription}
            onChange={(event) => {
              form.setFieldValue(
                'serviceDescription',
                event.currentTarget.value,
              );
            }}
            error={form.errors.serviceDescription}
            data-cy="serviceDescription"
          />
        </Grid.Col>
        <Grid.Col xs={12}>
          <CheckboxGroup
            placeholder={placeHolder.modeOfPayment}
            label={label.modeOfPayment}
            value={form.values.modeOfPayment.map((mop) => {
              return mop.toString();
            })}
            onChange={(value) => {
              const parsed = value.map((str) => {
                return parseInt(str);
              });
              form.setFieldValue('modeOfPayment', parsed);
            }}
            error={form.errors.modeOfPayment}
            data-cy="modeOfPayment"
            description="Select as many that apply"
          >
            <Checkbox
              value={BusinessModeOfPayments.TERMINAL.toString()}
              label="Terminal"
            />
            <Checkbox
              value={BusinessModeOfPayments.ECOM.toString()}
              label="Ecom"
            />
            <Checkbox
              value={BusinessModeOfPayments.PAYMENT_LINK.toString()}
              label="Payment Link"
            />
            <Checkbox
              value={BusinessModeOfPayments.QRPH.toString()}
              label="QR Ph"
            />
            <Checkbox
              value={BusinessModeOfPayments.PAY_WITH_MAYA.toString()}
              label="Pay with Maya"
            />
          </CheckboxGroup>
        </Grid.Col>
        <Grid.Col xs={12}>
          <Select
            placeholder={placeHolder.currency}
            label={label.currency}
            value={form.values.currency && form.values.currency.toString()}
            data={CurrenciesData}
            onChange={(value: string) => {
              form.setFieldValue('currency', parseInt(value));
            }}
            error={form.errors.currency}
            data-cy="currency"
          />
        </Grid.Col>
        <Grid.Col>
          <TextInput
            placeholder={placeHolder.aubPartnerId}
            label={label.aubPartnerId}
            value={form.values.aubPartnerId}
            onChange={(event) => {
              form.setFieldValue('aubPartnerId', event.currentTarget.value);
            }}
            error={form.errors.aubPartnerId}
          />
        </Grid.Col>
        <Grid.Col xs={12}>
          <TextInput
            placeholder={placeHolder.estimatedMonthlyGrossTransaction}
            label={label.estimatedMonthlyGrossTransaction}
            value={form.values.estimatedMonthlyGrossTransaction}
            onChange={(event) => {
              form.setFieldValue(
                'estimatedMonthlyGrossTransaction',
                event.currentTarget.value,
              );
            }}
            error={form.errors.estimatedMonthlyGrossTransaction}
            data-cy="estimatedMonthlyGrossTransaction"
          />
        </Grid.Col>
        {!isNonAdminInterface && (
          <Grid.Col xs={12}>
            <CheckboxGroup
              label={label.acquirer}
              value={form.values.acquirers?.map((acquirers) => {
                return acquirers.toString();
              })}
              onChange={(value) => {
                const parsed = value.map((str) => {
                  return parseInt(str);
                });
                form.setFieldValue('acquirers', parsed);
              }}
              error={form.errors.acquirers}
              description="Select as many that apply"
            >
              <Checkbox value={AcquirerTypes.AUB.toString()} label="AUB" />
              <Checkbox
                value={AcquirerTypes.UNIONBANK.toString()}
                label="Unionbank"
              />
              <Checkbox value={AcquirerTypes.MAYA.toString()} label="Maya" />
            </CheckboxGroup>
          </Grid.Col>
        )}

        <Grid.Col>
          <Divider my="md" />
        </Grid.Col>
      </Grid>
    </>
  );
}

export default UpdateMerchantDescription;
